'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.INITIAL_MESSAGE), _defineProperty(_Record, 'from', null), _defineProperty(_Record, 'text', null), _defineProperty(_Record, 'welcomeMessageId', null), _defineProperty(_Record, 'richText', null), _defineProperty(_Record, 'url', null), _defineProperty(_Record, 'quickReply', null), _defineProperty(_Record, 'previousMessageClientTs', null), _Record), 'InitialMessageMetadata');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/PubNubMessageMetadata/InitialMessageMetadata.js
// module id = 711
// module chunks = 2 3